import UgcToolsControlsWrapper from "./ControlsWrapper";

export default UgcToolsControlsWrapper;
